import React from 'react';
import PropTypes from 'prop-types';
import { ProductSlideContentV1 } from '../ProductSlideContentV1';
import { ProductSlideContentV2 } from '../ProductSlideContentV2';
import { ProductSlideContentV3 } from '../ProductSlideContentV3';
import { ProductSlideContentV4 } from '../ProductSlideContentV4';
import { ProductSlideContentV5 } from '../ProductSlideContentV5';
import { ProductSlideContentV8 } from '../ProductSlideContentV8';
import { ProductSlideContentV9 } from '../ProductSlideContentV9';
import { ProductSlideContentV16 } from '../ProductSlideContentV16';
import { ProductSlideContentV17 } from '../ProductSlideContentV17';

const PRODUCT_SLIDE_VARIANTS = {
    v1: ProductSlideContentV1,
    v2: ProductSlideContentV2,
    v3: ProductSlideContentV3,
    v4: ProductSlideContentV4,
    v5: ProductSlideContentV5,
    v8: ProductSlideContentV8,
    v9: ProductSlideContentV9,
    v16: ProductSlideContentV16,
    v17: ProductSlideContentV17
};

function ProductSlide({ variant = 'v1', ...contentProps }) {
    const Content = PRODUCT_SLIDE_VARIANTS[variant] || ProductSlideContentV1;

    return <Content {...contentProps} />;
}

ProductSlide.propTypes = {
    variant: PropTypes.oneOf(Object.keys(PRODUCT_SLIDE_VARIANTS))
};

export {
    ProductSlide
};
